import DMAService from 'services/DMAService';
import 'shared/global';
import 'shows/parentalControlsPin.js';
import 'bundles/collectionsTracking';
import hubCollectionConfigurator from 'carousels/hubCollectionConfigurator';

// import hero.js conditionally since it's not needed for the collections browse page
(async () => {
    if (__hub?.hubPageType === 'news') {
        await import('bundles/news/newsLiveHero.js');
    }
    if (__hub?.hubPageType !== 'browse') {
        await import('components/hero.js');
    }
})();

let dmaService = new DMAService();
dmaService
    .getDMA()
    .then()
    .catch((error) => {
        console.error('Failed to get DMA on Collections/HUB Page:', error);
    });

hubCollectionConfigurator();

// START A/B TEST PLGRWEB-1558 Live Sports Data Carousel
try {
    if (CBS?.AbTestsConfigs?.modules?.LiveSportsDataCarousel) {
        (async () => {
            const LiveSportsDataCarousel = (
                await import(`abTests/testClasses/LiveSportsDataCarousel`)
            ).default;
            new LiveSportsDataCarousel();
        })();
    }
} catch (e) {
    console.error('AB Test LiveSportsDataCarousel failed to load');
}
// END A/B TEST PLGRWEB-1558 Live Sports Data Carousel
